<div fxLayout="column" class="h-100">
  <article fxLayout="column" fxFlex="grow" fxLayoutAlign="center center">
    <h1 class="m-0 mat-color-accent" style="font-size: 10rem; line-height: 10rem;">404</h1>
    <h1 class="mt-2">Page Not Found</h1>
    <a class="mt-5" routerLink="/" color="primary" mat-raised-button>Go to home page</a>
  </article>
</div>